// Google Analytics 4 (gtag.js) bootstrap + event helper.
// Measurement ID comes from the Lovable Google Analytics connector.

/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

const MEASUREMENT_ID = import.meta.env
  ["VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY"] as string | undefined;

let initialized = false;

export const gtag = (...args: unknown[]) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
};

export const initGA = () => {
  if (initialized || typeof window === "undefined") return;
  if (!MEASUREMENT_ID) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // Route changes are sent manually from the tracker.
  gtag("config", MEASUREMENT_ID, { send_page_view: false });
};

/** Send a GA4 event. Safe no-op when GA isn't configured. */
export const gaEvent = (event: string, params: Record<string, unknown> = {}) => {
  if (!MEASUREMENT_ID) return;
  initGA();
  gtag("event", event, params);
};

export const gaPageView = (path: string, title?: string) => {
  if (!MEASUREMENT_ID) return;
  initGA();
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
  });
};

export const isGAConfigured = () => Boolean(MEASUREMENT_ID);
